export const stepKeyMap = {
  fields: 0,
  daily_hours: 1,
  signature_dishes: 2,
  chef: 3
}

export const getFieldsName = (index) => {
  switch (index) {
    case 0:
      return "fields"
    case 1:
      return "daily_hours"
    case 2:
      return "signature_dishes"
    case 3:
      return "chef"
    default:
      return "fields"
  }
}

export const filterSections = (keywords = [], dynamicFieldsGroup) =>
  dynamicFieldsGroup?.filter((section) =>
    keywords.some((keyword) => section.key.toLowerCase().includes(keyword))
  )

export const filterTypeSections = (keywords = [], dynamicFieldsGroup) =>
  dynamicFieldsGroup?.filter((section) =>
    keywords.some((keyword) => section.type.toLowerCase().includes(keyword))
  )

export const excludeSections = ({ keys = [], types = [] }, dynamicFieldsGroup) =>
  dynamicFieldsGroup?.filter(
    (section) =>
      !keys?.some((keyword) => section.key?.toLowerCase().includes(keyword)) &&
      !types?.some((typeKeyword) => section.type?.toLowerCase().includes(typeKeyword))
  )

export const getValueByPath = (obj, path) => path.split(".").reduce((acc, key) => acc?.[key], obj)
